<app-segov-sigepo-portal-body>
  <app-segov-sigepo-header-section [Title]="title" [RouteStack]="RouteStack" />

  <div *ngIf="pesquisouPrimeiraVez" class="default-spacing-title">
    <h3 style="color: var(--tom-2-informativo);">Reportagens Históricas</h3>
    <h4 style="margin-bottom: 3rem;">A seguir estão relacionadas algumas notícias de destaque de Minas, do Brasil e do
      mundo, que foram veiculadas pelo Diário Oficial</h4>

    <div style="border-bottom-color: var(--tom-2-informativo); border-bottom-width: 2px; border-bottom-style: solid;">
    </div>
    <app-menu-reportagens  [menusReportagem]="menusReportagem"
      (topicoOutput)="obterTopicoClicado($event)"
      (primeiraInicializacao) = "$event"
      [menuReportagemSelectedItemOnStartInput]="primeiraInicializacao">    
    </app-menu-reportagens>
  </div>
</app-segov-sigepo-portal-body>
